<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xl-8 no-padding">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Operating system information</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="form-group col-md-23 col-sm-23 col-xs-23  no-padding" style="margin-bottom:20px; ">
                <div class="form-floating" >
                    <select (change)="osVendorChanged($event)" class="form-select" id="osVendorSelect" aria-label="Floating label select example">
                        <option *ngFor="let vendorI of vendorInformation" [value]="vendorI.Vendor">
                            {{ vendorI.Vendor }}
                        </option>
                    </select>
                    <label for="floatingSelect">Operating system name</label>
                </div>
            </div>
            <div class="form-group col-md-23 col-sm-23 col-xs-23  no-padding" style="margin-bottom: 20px; " *ngIf="operatingSystem">
                <div class="form-floating" >
                    <select class="form-select" id="osSelect" aria-label="Floating label select example">
                        <option *ngFor="let osI of OSInformation">
                            {{ osI.os}}
                        </option>
                    </select>
                    <label for="floatingSelect">Operating system version</label>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Product information</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px; ">
                <div class="form-floating" >
                    <select (change)="SelectProductVendor($event)" class="form-select" id="productVendorSelect" aria-label="Floating label select example">
                        <option *ngFor="let product of productInformation" [value]="product.Vendor">
                            {{ product.Vendor }}
                        </option>
                    </select>
                    <label for="floatingSelect">Vendor</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px; " *ngIf="category">
                <div class="form-floating" >
                    <select (change)="selectProductMainCategory($event)" class="form-select" id="productMainCategorySelect" aria-label="Floating label select example">
                        <option *ngFor="let pmc of productMainCategories" [value]="pmc.MainCategoryName">
                            {{ pmc.MainCategoryName}}
                        </option>
                    </select>
                    <label for="floatingSelect">Category</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px;  " *ngIf="subcategory">
                <div class="form-floating" >
                    <select (change)="selectProductSubCategory($event)" class="form-select" id="productSubCategorySelect" aria-label="Floating label select example">
                        <option *ngFor="let psc of productSubCategories" [value]="psc.SubCategoryName">
                            {{ psc.SubCategoryName}}
                        </option>
                    </select>
                    <label for="floatingSelect">Sub category</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px; " *ngIf="product">
                <div class="form-floating" >
                    <select class="form-select" id="productSelect" aria-label="Floating label select example">
                        <option *ngFor="let prod of products" [value]="prod">
                            {{ prod }}
                        </option>
                    </select>
                    <label for="floatingSelect">Product</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                <div class="form-floating">
                    <input [(ngModel)]="Case.CaseObject.Product_Version__c" type="text" class="form-control" id="floatingInputValueSubject">
                    <label for="floatingInputValueSubject">Product version</label>
                </div>
            </div>
            
        </div>

        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top: 20px">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Case information</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                <div class="form-floating">
                    <input [(ngModel)]="Case.CaseObject.Subject" type="text" class="form-control" id="floatingInputValueSubject">
                    <label for="floatingInputValueSubject">Subject</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px; ">
                <div class="form-floating" style="margin-right: 5px">
                    <select class="form-select" id="severitySelect" aria-label="Floating label select example">
                        <option *ngFor="let severity of severityLevel" [value]="severity.id">
                            {{ severity.name }}
                        </option>
                    </select>

                    <label for="floatingSelect">Severity level</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">
                <div class="form-floating">
                    <textarea [(ngModel)]="Case.CaseObject.Description" style="height:150px" class="form-control" placeholder="Leave your description here..." id="floatingTextareaDescription"></textarea>
                    <label for="floatingTextareaDescription">Description</label>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top:20px">
                <div class="form-group">
                    <div clas="col-md-3" style="padding-top:15px ">
                        <div class="form-row">
                            <input type="file" (change)="filesSelect($event)" name="file" id="file" class="inputfile" />
                            <label for="file">ADD Attachment <i class="far fa-file"></i></label>
                        </div>
                    </div>
                    <table class="table" *ngIf="files.length > 0">
                        <thead>
                            <tr>
                                <th width="50%">Name</th>
                                <!--<th>Size</th>-->
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of files;let i = index">
                                <td><strong>{{ item.name }}</strong></td>
                                <!--<td  nowrap>{{ item.size/1024/1024|number:2 }} MB</td>-->
                                <td nowrap>
                                    <a style="cursor:pointer" (click)="removeFile(i)">
                                        <span class="fa fa-trash"></span> Remove
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="" style="margin-top: 20px;margin-bottom:20px">
                <div style="text-align: right" class="col-md-12 col-sm-12 col-xs-12">
                    <button ng-disabled="btnSubmitDisabled" class="btn mygistec-main-btn" (click)="submitCase()">{{btnSubmitText}}</button>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="!isError" class="col-xl-4" style="padding-right: 0px; padding-left: 30px;">
        <div class="row" style="margin-bottom:15px !important">
            <!--Request details-->
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Request Details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div class="row small-section-content">
                    <div class="col-xl-12 no-padding">
                        <div style="font-weight: bold;">Support type</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{supportTypeName}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:10px">
                        <div style="font-weight: bold;font-size: 17px;">Requester name</div>
                        <div style="margin-top:10px">
                            <img [src]="authentication.userData.contactLogo" style="width: 30px;height:30px; border-radius: 50%;" />
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd; padding-left: 10px;">{{authentication.userData.firstName}} {{authentication.userData.lastName}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;font-size: 17px;">Requester account</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{authentication.userData.portalAccount.name}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;font-size: 17px;">Request Origin</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">Web</p>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>
